export default __webpack_public_path__ + "static/media/voting.5f1d796d.gif";